import { isSubscriptionExpired } from "@/react/helpers/communityHelpers";
import {
  memberProfileModalPaths,
  settingsNavPathV3,
} from "@/react/helpers/urlHelpers";
import type { CurrentCommunity } from "@/react/types/CurrentCommunity";

const WHITELISTED_PATHS = [
  settingsNavPathV3.plans.general,
  settingsNavPathV3.plans.billing,
  settingsNavPathV3.plans.brandedApps,
  settingsNavPathV3.plans.invoices,
  settingsNavPathV3.plans.payment_details,
  memberProfileModalPaths.partner_program,
];

/**
 * Matches pathname against whitelisted base paths. Used in both React components
 * and TanStack Router beforeLoad, so we cannot rely on useRouteMatch.
 *
 * We require either exact match or a trailing "/" so that we only match real
 * subpaths and avoid segment false positives (e.g. /settings/plans-foo must
 * not match the /settings/plans base path).
 */
const isWhitelistedPath = (pathname: string) =>
  WHITELISTED_PATHS.some(
    path =>
      pathname === path ||
      (pathname.startsWith(path) && pathname[path.length] === "/"),
  );

export const checkIfProtectedRouteCanBeSeen = (
  pathname: string,
  currentCommunity?: CurrentCommunity,
) => {
  const isCurrentRouteWhitelisted = isWhitelistedPath(pathname);
  const hasExpiredSubscription = isSubscriptionExpired(currentCommunity);
  return isCurrentRouteWhitelisted || !hasExpiredSubscription;
};
